import {useMemo} from 'react';
import {Input as BaseInput} from '@base-ui/react/input';
import CircularProgress from '@mui/material/CircularProgress';

interface InputProps {
    className?: string;
    placeholder?: string;
    value?: string;
    disabled?: boolean;
    defaultValue?: string;
    error?: boolean;
    required?: boolean;
    autoComplete?: string;
    type?: string;
    onChange?: (value: string) => void;
    id?: string;
    loading?: boolean;
    statusIcon?: string;
    onIconClick?: () => void;
    warning?: boolean;
    valid?: boolean;
    label?: string;
    errorHelperText?: string;
}

export default function Input({
    className,
    placeholder,
    value,
    disabled,
    defaultValue,
    error,
    required,
    autoComplete,
    type,
    onChange,
    id,
    loading,
    statusIcon,
    onIconClick,
    warning,
    valid,
    label,
    errorHelperText,
}: InputProps) {
    const renderStatus = useMemo(() => {
        /**
         *
         */
        const handleIconClick = () => {
            if (onIconClick) {
                onIconClick();
            }
            return;
        };

        if (loading) {
            return <div onClick={() => handleIconClick()} className='inputStatusWrapper'>
                <CircularProgress className="inputLoading" size="1.3rem"/>
            </div>;
        }

        if (statusIcon === 'success') {
            return <div onClick={() => handleIconClick()} className='inputStatusWrapper'>
                <span className="inputStatus iconfas-success"></span>
            </div>;
        }

        if (statusIcon === 'error') {
            return <div onClick={() => handleIconClick()} className='inputStatusWrapper'>
                <span className="inputStatus iconfas-error"></span>
            </div>;
        }

        if (statusIcon === 'search') {
            return <div onClick={() => handleIconClick()} className='inputStatusWrapper'>
                <span className="inputStatus iconfa-search"></span>
            </div>;
        }

        if (statusIcon === 'warning') {
            return <div className='inputStatusWrapper'><span className="inputStatus iconfas-warning"></span></div>;
        }

        return null;
    }, [loading, statusIcon, onIconClick]);

    const wrapperClass = useMemo(() => {
        const classes = ['Input', className];

        if (disabled) classes.push('disabled');
        if (error) classes.push('error');
        if (warning) classes.push('warning');
        if (valid) classes.push('valid');

        return classes.filter(Boolean).join(' ');
    }, [className, disabled, error, warning, valid]);

    const requiredPlaceholder = !label && required ? ' *' : '';

    return (
        <div className='InputWrapper'>
            {label && <label className='formElementLabel'>{label}{required ? <span className='required'>*</span> : null}</label>}
            <div className={wrapperClass}>
                <BaseInput
                    placeholder={placeholder + requiredPlaceholder}
                    value={value}
                    defaultValue={defaultValue}
                    onValueChange={(val) => onChange && onChange(val)}
                    disabled={disabled}
                    required={required}
                    autoComplete={autoComplete}
                    type={type}
                    id={id}
                />
            </div>
            {renderStatus}
            {error && errorHelperText && <div className='errorText'>{errorHelperText}</div>}
        </div>
    );
}
